import * as React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import BootstrapTooltip from 'react-bootstrap/Tooltip';
const Tooltip = ({ id, content, placement, children, }) => (React.createElement(OverlayTrigger, { placement: placement, overlay: (React.createElement(BootstrapTooltip, { id: `tooltip-${id}` }, content)) }, children));
Tooltip.defaultProps = {
    placement: 'right',
};
export default Tooltip;
